import { DateFilterOptions, DocumentSchema, FilterGroup, QueryParams, Workflow } from 'src/app/modules/core/store/models';
import { Dataset, DatasetSubtype, DatasetType } from 'src/app/modules/core/store/models/dataset.model';

export interface DataMartRequest {
  datasetType?: DatasetType;
  datasetSubtype?: DatasetSubtype;
  documentRequest?: CountGroupByFieldRequest;
  datasetUId?: string;
  fields?: string[];
  requestTranslations: { [x: string]: FieldTranslations };
}

export interface FieldTranslations {
  [x: string]: string;
}

export interface CountGroupByFieldRequest {
  schema?: DocumentSchema;
  queryParams?: QueryParams;
  groupFields?: CountByFieldRequestGroup[];
  workflow?: Workflow;
  includeFilteredValues?: boolean;
  excludeEmptyValues?: boolean;
  dateInterval?: DateFilterOptions;
  fields?: string[];
}

export interface CountByFieldRequestGroup {
  field: string;
  displayField?: string;
  colorField?: string;
  translationKey?: string;
}

export interface CountByFieldResult {
  fieldValue: CountByFieldValue[];
}

export interface CountByFieldValue {
  groups: CountByFieldGroup[];
}

export interface CountByFieldGroup {
  count: number;
  value: any;
  displayName?: string;
  color?: string;
  displayHasTranslation?: boolean;
}

export enum SyncState {
  none = 0,
  started = 1,
  finished = 2,
  cleared = 3,
  error = 4
}

export interface SyncProgress {
  uId?: string | null;
  organizationUId?: string | null;
  syncUId?: string | null;
  syncedOn?: string;
  orgCode?: string | null;
  type?: DatasetType;
  subType?: DatasetSubtype;
  updatedOn?: string;
  state: SyncState;
  datasetUId?: string;
  datasetName?: string;
  total?: number;
  index?: number;
  message?: string | null;
}

export interface ResponseMetrics {
  uId?: string | null;
  organizationUId: string | null;
  startTime?: string | null;
  changeTime?: string | null;
  hourOffset?: number | null;
  newRecords: number | null;
  escalatedRecords: number | null;
  clearedRecords: number | null;
  mttaSeconds: number | null;
  mttrSeconds: number | null;
  escalatedUnderTarget: number | null;
  clearedUnderTarget: number | null;
  datasetUIds: string[] | null;
}

export interface ResponseWorkflowMetrics {
  uId?: string | null;
  organizationUId: string | null;
  startTime?: string | null;
  changeTime?: string | null;
  hourOffset?: number | null;
  statusMetrics: ResponseWorkflowStatusMetrics[];
}

export interface ResponseWorkflowStatusMetrics {
  workflowStepUId: string | null;
  statusUId: string | null;
  datasetUIds: string[] | null;
  statusName?: string | null;
  statusColor?: string | null;
  totalRecords: number | null;
  averageTimeInStepSeconds: number | null;
  numberOfNotCompletedSteps: number;
}

export interface WorkflowMetricsDocumentsByTimeRequest {
  datasetUId: string;
  fromTime: string;
  toTime: string;
  sorting: string | null;
  where: string | null;
  statusUId: string | null;
  preFilterType: WorkflowStepDocumentPreFilterType;
  stepDetailsType: WorkflowStepDetailsType;
  createTime: string | null;
  documentUIds: string[];
  fieldNames: string[] | null;
  skip: number;
  take: number;
  countOnly: boolean;
}

export interface GetResponseMetricsDrillDownReportRequest {
  fromTime: string;
  toTime: string;
  datasetUIds: string[];
  title: string;
  targetEmails: string;
  isMTTA: boolean;
  includeWorkflowDetails: boolean;
  sort?: string;
}

export enum WorkflowStepDetailsType {
  All = 0,
  MTTA = 1,
  MTTR = 2
}

export enum WorkflowStepDocumentPreFilterType {
  None = 0,
  MTTAOnly = 1,
  MTTROnly = 2
}

export enum ResponseMetricsRange {
  None = 0,
  Day = 1, // 24 hours
  Month = 2, // 30 days
  Quarters = 3, // 4 Quarters
  Year = 4, // 12 month
  Custom = 5, // 
  MultipleYears = 6 // 10 years
}

export interface ResponseMetricsRequest {
  escaledNumberOfMinutes?: number;
  clearedNumberOfMinutes?: number;
  offsetFromRange?: number;
  range?: ResponseMetricsRange;
}

export interface ResponseMetricsResult {
  metrics?: ResponseMetrics[];
  range?: ResponseMetricsRange;
}

export interface ResponseWorkflowMetricsResult {
  metrics?: ResponseWorkflowMetrics[];
  range?: ResponseMetricsRange;
}

export interface ResponseMetricsDocumentsResult {
  datasets?: Dataset[];
  documents?: Document[];
}
